import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default (
  <Route key="/consumer/apps/yca" element={<DefaultConsumerLayout />}>
    <Route path="consumer/apps/yca" element={<AsyncPage />} />
  </Route>
);
